import React from 'react';
import Advertisement from '../../components/Advertisement/Advertisement';

/**
 * Small component to render a banner ad
 *
 * @param count
 */
const AdWrapper = ({ count, variant }) => {
  return (
    <div style={{ width: '100%' }} className="advertisement">
      <Advertisement variant={variant} count={count} />
    </div>
  );
};

export default AdWrapper;
